import { PropsWithChildren, RefObject, forwardRef, useContext, useEffect } from 'react';
import { KeypressContext } from '../Providers/keypressContext';
import { MinimalDisclosure } from 'Guide/Schematics/Diagram/Logic/minimalDisclosure';
import { Modal as ChakraModal, ModalOverlay, ModalContent, ModalBody } from '@chakra-ui/react';

const simulateClickOnActiveEl = () => {
   const event = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
      buttons: 1,
   });
   // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
   document.activeElement.dispatchEvent(event);
};

// @ts-expect-error TS(2345) FIXME: Argument of type '({ isOpen, onClose, children }: ... Remove this comment to see the full error message
const Modal = forwardRef(function ModalForwarded(
   { isOpen, onClose, children }: PropsWithChildren<MinimalDisclosure>,
   ref: RefObject<HTMLDivElement | null>
) {
   const keypressContext = useContext(KeypressContext);

   useEffect(() => {
      const mappings = [
         { id: 'Modal', key: 'Escape', action: onClose },
         { id: 'Modal', key: ' ', action: simulateClickOnActiveEl },
      ];
      // @ts-expect-error TS(2345) FIXME: Argument of type '{ id: string; key: string; actio... Remove this comment to see the full error message
      keypressContext.pushMappings(mappings);
      return () => {
         // @ts-expect-error TS(2345) FIXME: Argument of type '{ id: string; key: string; actio... Remove this comment to see the full error message
         keypressContext.popMappings(mappings);
      };
   }, [keypressContext.pushMappings, keypressContext.popMappings, onClose]);

   return (
      <ChakraModal
         isOpen={isOpen}
         // @ts-expect-error TS(2322) FIXME: Type '(() => void) | undefined' is not assignable ... Remove this comment to see the full error message
         onClose={onClose}
         size="full"
         scrollBehavior="inside"
         blockScrollOnMount={true}
         allowPinchZoom={true}
         closeOnOverlayClick={false}
         closeOnEsc={false}
      >
         <ModalOverlay backdropFilter="blur(10px)" background="rgba(227, 232, 237, 0.75)" />
         <ModalContent width="100vw" height="100vh" background="none">
            <ModalBody width="100%" height="100%" padding="0" margin="0" ref={ref}>
               {children}
            </ModalBody>
         </ModalContent>
      </ChakraModal>
   );
});

export default Modal;
